export const pebble = {
  name: "pebble" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M22.125 6.569c0-3.766-2.736-5.069-5.76-5.069-6.338 0-14.115 4.2-14.115 9.559 0 4.2 5.617 11.441 9.793 11.441 4.033 0 10.082-6.662 10.082-15.931Z" clip-rule="evenodd"/></svg>`,
  keywords: ["pebble"],
  category: "other" as const,
};
